import * as Immutable from 'immutable';
import {
  GET_PLANVALUEOVERTIME_ABORTED,
  GET_PLANVALUEOVERTIME_REQUESTED,
  GET_PLANVALUEOVERTIME_COMPLETED,
  GET_PLANVALUEOVERTIME_FAILED,
  // RESET_PLANVALUEOVERTIME_REQUESTED,
  // RESET_PLANVALUEOVERTIME_COMPLETED,
} from '../../actions/planvalueovertime/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLANVALUEOVERTIME_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_PLANVALUEOVERTIME_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_PLANVALUEOVERTIME_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_PLANVALUEOVERTIME_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
